import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Pagination, Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import AddExternalAccounts from './addExternalAccount';
import "./hm-theme.css";

function ExternalAccountDetails() {
  const [loading, setLoading] = useState(false);
  const [externalAccounts, setExternalAccounts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const searchUrl = `/api/externalaccount`;
      const response = await axios.get(searchUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExternalAccounts(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const trans = await axios.get(`/api/externalaccount/getAll`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });
      setExternalAccounts(trans.data.content || []);
      setCurrentPage(trans.data.number || 0);
      setTotalPages(trans.data.totalPages || 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  const handleAddAccounts = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const filteredData = externalAccounts.filter((agent) =>
    (agent.username && agent.username.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (agent.appname && agent.appname.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }
    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  return (
    <div className="hm-page-wrapper">
      <Dashboard />
      {loading && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-card">
          {/* Header */}
          <div className="hm-card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
            <h5 className="hm-card-title m-0">
              <i className="material-icons">api</i>
              External Account Details
            </h5>
            <button className="btn-hm-primary" onClick={handleAddAccounts}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
              Add Account
            </button>
          </div>

          <div className="hm-card-body p-4">
            {/* Search Bar */}
            <div className="row mb-4">
              <div className="col-md-5 col-lg-4">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control ps-4"
                    placeholder="Search by App name or Email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ borderRadius: "50rem" }}
                  />
                  <span className="position-absolute" style={{ left: "12px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }}>
                    <FontAwesomeIcon icon={faSearch} />
                  </span>
                </div>
              </div>
            </div>

            {/* Cards Grid */}
            <Row g={3}>
              {filteredData.map((accd) => (
                <Col key={accd.id} md={6} lg={4} className="mb-4">
                  <div className="h-100 p-4 rounded-3 shadow-sm border bg-white position-relative" style={{ borderLeft: "4px solid #2f3a88" }}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fw-bold text-dark m-0 d-flex align-items-center gap-2">
                        <i className="material-icons text-primary" style={{ fontSize: "1.2rem" }}>apps</i>
                        {accd.appname}
                      </h6>
                      <span className="hm-badge hm-badge-active">Active</span>
                    </div>

                    <div className="small text-secondary space-y-2">
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>email</i>
                        <span className="text-truncate"><strong>Email:</strong> {accd.username}</span>
                      </div>
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>event</i>
                        <span><strong>Validity:</strong> {accd.validity}</span>
                      </div>
                      <div className="d-flex align-items-start gap-2">
                        <i className="material-icons mt-1" style={{ fontSize: "1rem" }}>vpn_key</i>
                        <span className="text-break">
                          <strong>Token:</strong> <code className="small text-dark p-1 rounded bg-light">{accd.token}</code>
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}

              {filteredData.length === 0 && !loading && (
                <div className="text-center py-5 text-muted">
                  <i className="material-icons display-4 mb-2">no_accounts</i>
                  <p className="fw-semibold mb-0">No external accounts found</p>
                </div>
              )}
            </Row>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <Pagination>
                  <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                  <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                  {renderPageNumbers()}
                  <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                  <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                </Pagination>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <AddExternalAccounts isOpen={isModalOpen} onRequestClose={handleCloseModal} />
      )}
    </div>
  );
}

export default ExternalAccountDetails;